module.exports = __webpack_public_path__ + "static/media/sriracha-egger-hero-desktop.5e0ed71a.jpg";